import React, { useEffect, useState } from 'react';
import Auth from '../../Auth';
import { StyledContainer } from './styles';
let dateFormat = require("dateformat");

export default function Usage({

}) {

  const [data, setData] = useState(null);

  useEffect(() => {
    async function get() {
      const res = await Auth.fetchWithIdToken("/api/usage", {});

      setData(res);
    }

    get();
  }, []);

  let start, end, sorted, total = 0;
  if (data) {
    start = new Date(data.start);
    end = new Date(data.end);

    sorted = [];

    for (let email in data.totals) {
      sorted.push([email, data.totals[email]]);
      if (typeof data.totals[email] === "number") {
        total += data.totals[email];
      }
    }

    sorted.sort(function (a, b) {
      return b[0] < a[0] ? 1 : -1;
    });

    console.log(sorted);

    // sorted = sorted.map(s => s[1]);
  }

  return (
    <StyledContainer>
      <div className="inner">
        {!data &&
          <h1>Loading...</h1>
        }
        {data &&
          <>
            <h1>Account Usage</h1>
            <p>For period: {dateFormat(start, "mmm d, yyyy")} to {dateFormat(end, "mmm d, yyyy")} </p>

            <h2>Word Output Totals</h2>
            <ul>
              {sorted.map(total => {
                return <li>{total[0]}: {total[1]}</li>;
              })}
            </ul>

            <p>Grand total: {total}</p>
          </>
        }
      </div>

    </StyledContainer>
  );
}
